// import Toggle from 'accessible-toggle';
// import throttle from 'raf-throttle';
// import { $ } from '../lib/domUtils';

// // Add class to header when scrolled down
// const checkScroll = throttle(() => {
//   document.body.classList.toggle('is-scrolled', window.scrollY > 50);
// });
// window.addEventListener('scroll', checkScroll);
//
// // Toggle the primary nav on mobile
// const headerNav = $('#header-nav');
// if (headerNav) {
//   new Toggle(headerNav, {
//     trapFocus: true,
//     assignFocus: true,
//   });
// }
//

import Headroom from 'headroom.js'
import hoverIntent from 'hoverintent'
import { on } from '../lib/domUtils'
import { addClass, toggleClass, removeClass } from '../lib/classie'

// select your header or whatever element you wish
const header = document.querySelector('#header')

const headroom = new Headroom(header, {
  // scroll tolerance in px before state changes
  tolerance: {
    up: 5,
    down: 0,
  },
})

const initHoverIntent = () => {
  const dropdownElmts = document.querySelectorAll('#header .dropdown-wrapper')

  if (!dropdownElmts || !dropdownElmts.length) {
    return false
  }

  for (let i = 0; i < dropdownElmts.length; i += 1) {
    const dropdown = dropdownElmts[i]
    hoverIntent(
      dropdown,
      () => {
        addClass(dropdown, 'is-active')
      },
      () => {
        removeClass(dropdown, 'is-active')
      },
    ).options({ timeout: 400 })
  }
}

const toggleIcon = () => {
  const hamburger = document.getElementById('hamburger-icon')

  on(hamburger, 'click', () => {
    toggleClass(header, 'mobile-menu-is-active')
    toggleClass(document.body, 'mobile-menu-is-active')
  })
}

const smoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault()

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      })
    })
  })
}

toggleIcon()
initHoverIntent()
headroom.init()
smoothScroll()
